const STEPS = [
  {
    key: 'welcomeVideo',
    isDone: (user) => !!user?.user_settings?.welcome_video_watched_at,
    title: 'portal.gettingStarted.welcomeVideo.title',
    note: 'portal.gettingStarted.welcomeVideo.duration',
    doneNote: 'portal.gettingStarted.done',
  },
  {
    key: 'certification',
    isDone: (user) => !!user?.certified,
    isSkipped: (user) => !!user?.user_settings?.certification_skipped_at,
    title: 'portal.gettingStarted.certification.title',
    note: 'portal.gettingStarted.certification.optional',
    doneNote: 'portal.gettingStarted.certification.doneNote',
    skippedNote: 'portal.gettingStarted.certification.skippedNote',
  },
]

export const gettingStartedSteps = (user) => STEPS.map(({ isDone, isSkipped, ...step }) => {
  const skipped = !!isSkipped?.(user) && !isDone(user)

  return { ...step, skipped, done: isDone(user) || skipped }
})

export const currentGettingStartedStep = (steps) => steps.find(step => !step.done) || steps[steps.length - 1]

export const isGettingStartedComplete = (user) => gettingStartedSteps(user).every(step => step.done)

export const stepNoteKey = (step) => {
  if (step.skipped) { return step.skippedNote }

  return step.done ? step.doneNote : step.note
}
